module.exports = __webpack_public_path__ + "static/img/img_03.3c94366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/1yuan365/img_03.jpg
// module id = deGI
// module chunks = 0